var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import _ from 'lodash';
import EntityUtil from 'gw-portals-util-js/EntityUtil';
import VehicleIncident from 'edge/fnol/ca/models/VehicleIncident';
import Vehicle from 'edge/fnol/ca/models/Vehicle';
import 'edge/fnol/common/models/Contact';

var CAClaimExtension = function () {
    function CAClaimExtension(claim) {
        var _this2 = this;

        _classCallCheck(this, CAClaimExtension);

        Object.defineProperty(this, '_claim', {
            enumerable: false,
            value: claim
        });
        if (this._claim.lobs.commercialAuto) {
            this.vehicles = _.map(this._claim.lobs.commercialAuto.vehicles, function (v) {
                return new Vehicle(v);
            });

            // correctly link up passengers, drivers with contact objects that already exist in the object hierarchy
            _.each(this._claim.lobs.commercialAuto.vehicleIncidents, function (vi) {
                var _this = this;

                vi.driver = this._claim._findContact(this._claim, vi.driver);
                _.each(vi.passengers, function (p, index) {
                    vi.passengers[index] = _this._claim._findContact(_this._claim, p);
                }, this);
                vi.vehicle = this._findVehicle(vi.vehicle);
            }, this);

            this.vehicleIncidents = _.map(this._claim.lobs.commercialAuto.vehicleIncidents || [], function (v) {
                return new VehicleIncident(_this2._claim, _this2, v);
            });

            this.fixedPropertyIncident = this._claim.lobs.commercialAuto.fixedPropertyIncident ? this._claim.lobs.commercialAuto.fixedPropertyIncident : { propertyDescription: undefined };
        } else {
            this.fixedPropertyIncident = { propertyDescription: undefined };
            this.vehicleIncidents = [];
            this.vehicles = [];
        }
    }

    _createClass(CAClaimExtension, [{
        key: 'generateVehicleIncidents',
        value: function generateVehicleIncidents(vehicles) {
            var _this3 = this;

            this.vehicleIncidents = vehicles.map(function (vehicle) {
                var vi = new VehicleIncident(_this3._claim, _this3);
                vi.tempID = EntityUtil.nextId();
                vi.vehicle = vehicle;
                return vi;
            });
        }
    }, {
        key: 'createVehicleIncident',
        value: function createVehicleIncident() {
            var vi = new VehicleIncident(this._claim, this);
            vi.tempID = EntityUtil.nextId();
            this.vehicleIncidents.push(vi);
            return vi;
        }
    }, {
        key: 'createVehicle',
        value: function createVehicle() {
            return new Vehicle({
                tempID: this._claim.nextId()
            });
        }
    }, {
        key: 'removeVehicleIncident',
        value: function removeVehicleIncident(incident) {
            var idx = this.vehicleIncidents.indexOf(incident);
            if (idx >= 0) {
                this.vehicleIncidents.splice(idx, 1);
            }
        }
    }, {
        key: 'availableVehicles',
        value: function availableVehicles(additional) {
            var _this4 = this;

            return _.filter(this.vehicles, function (v) {
                if (additional && v === additional) {
                    return true;
                }
                var used = _.find(_this4.vehicleIncidents, function (vi) {
                    return v === vi.vehicle;
                });
                return used === undefined;
            }, this);
        }
    }, {
        key: 'availableDrivers',
        value: function availableDrivers(additional) {
            return this.availablePassengers(additional);
        }
    }, {
        key: 'availablePassengers',
        value: function availablePassengers(additional) {
            return _.filter(this._claim.contacts, function (c) {
                if (additional && c === additional) {
                    return true;
                }
                var used = _.find(this.vehicleIncidents, function (vi) {
                    return c === vi.driver || _.some(vi.passengers, function (p) {
                        return c === p;
                    });
                });
                return used === undefined;
            }, this);
        }
    }, {
        key: '_findVehicle',
        value: function _findVehicle(vehicle) {
            return EntityUtil.findMatchingEntity(this.vehicles, vehicle, {
                Ctor: Vehicle
            });
        }
    }]);

    return CAClaimExtension;
}();

export default CAClaimExtension;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/fnol/ca/models/CAClaimExtension.js
// module id = 1506
// module chunks = 0